.readonlyTextarea {
  flex: 1;
  width: 100%;
  min-height: 420px;
  background: rgba(0, 0, 0, 0.25);
  border: 1px solid var(--color-border);
  border-radius: var(--radius-md);
  padding: var(--spacing-md);
  color: var(--color-text-muted);
  font-family: ui-monospace, "Cascadia Code", "Source Code Pro", Menlo, monospace;
  font-size: 0.75rem;
  line-height: 1.6;
  resize: none;
  outline: none;
  box-sizing: border-box;
}

.readonlyTextarea:focus {
  border-color: var(--color-accent);
}
